export const FACEBOOK_AD_TYPE = 'Facebook'
export const GOOGLE_DISPLAY_AD_TYPE = 'GoogleDisplay'
export const GOOGLE_SEARCH_AD_TYPE = 'GoogleSearch'
